var _style, _path, _path2, _rect, _rect2, _rect3, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconToolbarDelete = function SvgIconToolbarDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33 33",
    style: {
      enableBackground: "new 0 0 33 33"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#363636;}\r\n\t.st1{fill:#353535;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st0",
    d: "M21.5,7.3h-2V3.9c0-0.4-0.3-0.7-0.7-0.7h-6.2c-0.4,0-0.7,0.3-0.7,0.7v3.4h-2V3.9 c0-1.5,1.2-2.7,2.7-2.7h6.2c1.5,0,2.7,1.2,2.7,2.7V7.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st1",
    d: "M23.3,31.7H8.1c-1.4,0-2.6-1.2-2.6-2.6V10.7h20.4v18.4C25.9,30.5,24.8,31.7,23.3,31.7z M7.5,12.7 v16.4c0,0.3,0.3,0.6,0.6,0.6h15.2c0.3,0,0.6-0.3,0.6-0.6V12.7H7.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5_",
    x: 9.9,
    y: 11.9,
    className: "st0",
    width: 2,
    height: 18.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6_",
    x: 14.8,
    y: 11.8,
    className: "st0",
    width: 2,
    height: 19
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3_",
    x: 19.5,
    y: 11.9,
    className: "st0",
    width: 2,
    height: 18.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st0",
    d: "M27,6.4H4.5C4,6.4,3.6,6.8,3.6,7.3v0.4c0,0.5,0.4,0.9,0.9,0.9H27c0.5,0,0.9-0.4,0.9-0.9V7.3 C27.8,6.8,27.4,6.4,27,6.4z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconToolbarDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-toolbar-delete.b342d6a5.svg";
export { ForwardRef as ReactComponent };